import React from "react";
import {
  Book,
  Bookmark,
  Box,
  File,
  FilePlus,
  FileText,
  Mail,
  PlusSquare,
} from "react-feather";
// ** Reactstrap Imports
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import { Link } from "react-router-dom";

const AddNew = () => {
  return (
    <UncontrolledDropdown
      href="/"
      tag="li"
      className="dropdown-language nav-item"
      style={{
        border: "1px solid #E7E3E3",
        padding: "4px",
        borderRadius: "5px",
        marginRight: "8px",
      }}
    >
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link"
        onClick={(e) => e.preventDefault()}
      >
        <span className="selected-language">
          <PlusSquare size={18} /> New
        </span>
      </DropdownToggle>
      <DropdownMenu className="mt-0" end>      
        <DropdownItem to="/apps/work/all-projects" tag={Link}>
          <span className="me-1">
            <FileText size={18} />
          </span>
          Add New Project
        </DropdownItem>
        <DropdownItem to="/apps/work/milestones" tag={Link}>
          <span className="me-1">
            <FilePlus size={18} />
          </span>
          Add New Milestones
        </DropdownItem>
        <DropdownItem to="/apps/work/all-tasks" tag={Link}>
          <span className="me-1">
            <File size={18} />
          </span>
          Add New Task
        </DropdownItem>
        <DropdownItem to="/apps/all-leads" tag={Link}>
          <span className="me-1">
            <Book size={18} />
          </span>
          Add New Lead
        </DropdownItem>
        <DropdownItem to="/apps/clients/all-clients" tag={Link}>
          <span className="me-1">
            <Box size={18} />
          </span>
          Add New Client
        </DropdownItem>
        <DropdownItem to="/apps/hr/all-employees" tag={Link}>
          <span className="me-1">
            <Bookmark size={18} />
          </span>
          Add New Employee
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default AddNew;
